import axios from '../../../axios'



// 获取列表
export const list = (data) => {
  return axios({
    url: '/workorder/woInspection/list',
    method: 'post',
    data
  })
}

// 查看
export const view = (data) => {
  return axios({
    url: '/workorder/woInspection/view',
    method: 'post',
    data
  })
}

// 查看
export const getDeviceList = (data) => {
  return axios({
    url: '/workorder/woInspection/getDeviceList',
    method: 'post',
    data
  })
}

// 获取枚举类
export const singleDelete = (data) => {
  return axios({
    url: '/workorder/woInspection/delete',
    method: 'post',
    data
  })
}

// 保存信息
export const save = (data) => {
  return axios({
    url: '/workorder/woInspection/save',
    method: 'post',
    data
  })
}

// 开始执行
export const start = (data) => {
  return axios({
    url: '/workorder/woInspection/start',
    method: 'post',
    data
  })
}

// 结束执行
export const endExecute = (data) => {
  return axios({
    url: '/workorder/woInspection/endExecute',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/http/moudules/biz/workorder/woInspection.js